module.exports = __webpack_public_path__ + "static/img/goSmall.7abda018.png";